import React, { useState, useEffect } from 'react';
import { getUserCountry } from '../../utils/locationUtils';
import InternationalHero from './InternationalHero/InternationalHero';
import BrandsCarousel from '../BrandsCarousel/BrandsCarousel';
import './International.css';

const International = ({ userCountry }) => {
  const [displayCountry, setDisplayCountry] = useState('YOUR COUNTRY');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const detectCountry = async () => {
      try {
        let country;

        // If userCountry is passed as prop, use it
        if (userCountry) {
          country = userCountry;
        } else {
          // Otherwise detect location fresh
          country = await getUserCountry();
        }

        // Redirect users in countries where the main app is available
        const normalized = (country || '').replace(/_/g, ' ').toUpperCase();
        if (
          normalized === 'SOUTH AFRICA' ||
          normalized === 'NIGERIA' ||
          normalized === 'KENYA'
        ) {
          window.location.href = 'https://app.edcsquared.io';
          return;
        }

        setDisplayCountry(country);
      } catch (error) {
        // Fallback to default
        setDisplayCountry('YOUR COUNTRY');
      } finally {
        setIsLoading(false);
      }
    };

    detectCountry();
  }, [userCountry]);

  // Show loading spinner while detecting country
  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: '#1a1a1a',
          color: 'white',
          fontSize: '1.2rem',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <div
            style={{
              marginBottom: '1rem',
              width: '40px',
              height: '40px',
              border: '3px solid #333',
              borderTop: '3px solid #00B1B5',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '0 auto 1rem auto',
            }}
          />
          <div>Loading Information...</div>
          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
          </style>
        </div>
      </div>
    );
  }

  return (
    <div className="international-page">
      <section className="international-hero-wrapper">
        <div className="container">
          <InternationalHero userCountry={displayCountry} />
        </div>
      </section>
      <section className="international-brands-wrapper">
        <BrandsCarousel disabled={true} />
      </section>
    </div>
  );
};

export default International;
